<input type="text" #inputText [class.text-label-required]="required" [disabled]="disabled" [style.width.px]="width"
  [style.width]="undefined !== width ? width : '7rem'" [style.font-size]="fontSize" [readonly]="!editable"
  [maxLength]="7" plessInputTextSub [restrict]="'[0-9]'" [halfOnly]="true" [tabindex]="tabEnabled ? tabindex : -1"
  [(ngModel)]="text" [autofocus]="autofocus" (ngModelChange)="changeOrderCodeHandler();onChange($event);"
  (blur)="onTouched()" />
